import PageLoad from './PageLoad'

export default PageLoad
